<template>
  <div class="popup-container" :class="{ 'android-context': isAndroidContext }">
    <div class="overlay">
      <div class="popup">
        <h1 class="title font-size-big">{{ title }}</h1>
        <h2 class="time font-size-big">{{ remainingTime }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupTimer',
  props: {
    title: {
      type: String,
      default: ''
    },
    timer: {
      type: Number,
      default: 5
    },
    preparedUrl: {
      type: String,
      default: ''
    },
    isAndroidContext: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeRemaining: null,
    }
  },
  mounted () {
    this.timeRemaining = this.timer
    let timer = setInterval(() => {
      if (this.timeRemaining <= 0) {
        clearInterval(timer)
      } else {
        this.timeRemaining--
      }
    }, 1000)

  },
  computed: {
    remainingTime () {
      return `${this.timeRemaining} s`
    },
    paymentProcessReady () {
      return (this.preparedUrl !== '' && this.preparedUrl != null) &&
          (this.timeRemaining === 0 || this.preparedUrl)
    },
  },
  watch: {
    paymentProcessReady (newVal, oldVal) {
      if (newVal) {
        this.$emit('timerFinished')
      }
    },
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.popup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 5;

  .overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 6;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }

  &.android-context {
    .overlay {
      background: #000;
    }
  }

  &:not(.android-context) {
    .popup {
      border: solid 2px $gold;
    }
  }

  .popup {
    padding: 30px;
    z-index: 5;
    width: 550px;
    max-width: 90%;
    height: 250px;
    background: black;
    border-radius: 0.25rem;
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-content: center;

    .title, .time {
      text-align: center;
      margin: 0;
    }

    .title {
      font-weight: normal;
      margin-bottom: 10px;
    }

    .time {
      color: $gold;
    }
  }
}
</style>